import React from "react";
import Navbar from "../../components/Navbar.jsx";
import Footer from "../../components/Footer.jsx";
import Button from "../../components/Button.jsx";
import AlumniCards from "../../components/AlumniCards.jsx";
import EventsReunionSection from "./EventsReunionSection.jsx";
import { AlumniNews } from "../../Data.jsx";
import SuccessStorySection from "./SuccessStorySection.jsx";

export default function AlumniPage() {
  return (
    <div>
      <Navbar />
      <main className="">
        <div className="h-[115px] lg:h-[324px] w-full bg-cover bg-center bg-no-repeat bg-alumniBanner flex items-center justify-center">
          <h1
            className="font-montserrat font-extrabold text-[32px] md:text-4xl lg:text-5xl leading-4 tracking-[0.04em] text-secondary-light  "
            style={{ textShadow: "0 4px 4px rgba(0, 0, 0, 0.25)" }}
          >
            JMIF Alumni
          </h1>
        </div>
        <section className=" laptopSm:px-16 laptop:px-36 laptopSm:relative -top-20">
          <div className="bg-grey-normal px-4 mobileSm:px-8 md:px-16 py-8 grid gap-4 text-white">
            <h1 className="font-montserrat font-semibold text-2xl md:text-3xl laptopSm:text-4xl">
              About
            </h1>
            <p className="font-notoSans text-xs laptopSm:text-sm leading-6 tracking-[0.06em] text-justify">
              The JMIF Alumni Association is a vibrant community dedicated to
              fostering lifelong connections among graduates. Our mission is to
              support and engage alumni through networking opportunities,
              events, and initiatives that strengthen the bond between JMIF and
              its alumni. Whether you're reconnecting with old friends, sharing
              your successes, or giving back to the school, the Alumni
              Association is here to help you stay connected and contribute to
              the continued growth and excellence of JMIF. Join us as we
              celebrate the achievements of our alumni and work together to make
              a positive impact on future generations.
            </p>
            <button className="capitalize font-semibold text-sm bg-secondary-normal w-full md:w-[272px] flex items-center justify-center py-2 rounded-[100px] shadow-custom hover:scale-105 mt-2">
              Join Us Now
            </button>{" "}
          </div>
        </section>
        {/* section 2 */}
        {/* <section className=" responsive-padding mt-8 mb-8 grid gap-6">
          <h1 className="font-montserrat font-bold text-2xl md:text-3xl laptopSm:text-4xl text-text-dark leading-4 ">
            Events and Reunions
          </h1>
          <div>
            {AlumniNews.map((newsItem) => (
              <AlumniCards key={newsItem.id} newsItem={newsItem} />
            ))}
          </div>
        </section> */}
        <EventsReunionSection />
        <SuccessStorySection />
      </main>
      <Footer />
    </div>
  );
}
